import { Box, Skeleton, Text } from "@chakra-ui/react";

import { DEFAULT_LOCATION } from "scenes/Search/consts";
import { IMarginProps, IPaddingProps } from "src/types/types";
import { ISearchFilterState } from "utils/search";
import CustomLink, { ILinkProps } from "components/Chakra/CustomLink";
import IconArrowRight from "components/Chakra/Icons/ArrowRight";
import SearchLink from "components/Chakra/SearchLink";
import { DetailData } from "@ud/api/newPhpApi/__generated__/newPhpApi.generated";
import { createSearchUrl } from "scenes/Search/createSearchUrl";
import { getOfferType } from "scenes/OfferDetail/helper";

interface IProps extends IMarginProps, IPaddingProps {
  offer?: DetailData;
  isFallback: boolean;
}

type IFilterSearch = {
  filterState: Partial<ISearchFilterState>;
  opts: { location: string };
};

type IRoute = {
  text: string;
  link: IFilterSearch | ILinkProps;
};

function isSearchLink(
  searchLink: IFilterSearch | ILinkProps,
): searchLink is IFilterSearch {
  return (searchLink as IFilterSearch).filterState !== undefined;
}

const getNavigation = (offer?: DetailData): Array<IRoute> => {
  const links: Array<IRoute> = [
    { text: "Domů", link: { to: "/" } },
    {
      text: "Výpis nemovitostí",
      link: { filterState: {}, opts: { location: DEFAULT_LOCATION } },
    },
  ];

  if (offer) {
    const villageLabel = offer.village?.name ?? "";
    const villagePartLabel = offer.villagePart?.name ?? "";

    const searchLocationLinks = [
      { text: villageLabel, searchLocation: villageLabel },
    ];

    if (villagePartLabel !== "" && villageLabel !== villagePartLabel) {
      searchLocationLinks.push({
        text: villagePartLabel,
        searchLocation: `${villageLabel}, ${villagePartLabel}`,
      });
    }

    searchLocationLinks.map((item) =>
      links.push({
        text: item.text,
        link: {
          filterState: {},
          opts: {
            location: item.searchLocation,
          },
        },
      }),
    );
  }

  return links;
};

const OfferTitle: React.FC<{ offer: DetailData }> = ({ offer }) => (
  <Text display="inline" align="center" textAlign="center">
    {offer.title}
  </Text>
);

const BreadcrumbNavigation: React.FC<IProps> = ({ offer }) => {
  const navigations = getNavigation(offer);

  if (!offer) {
    <Skeleton>
      <Box w={["300px", "360px"]} h="20px" />
    </Skeleton>;
  }

  return (
    <Box py="8px" px={{ base: "16px", md: "unset" }} overflow="hidden" w="100%">
      <Box
        overflow="auto"
        whiteSpace="nowrap"
        pb="8px"
        pt="8px"
        __css={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        {navigations.map(({ link, text }, index) => (
          <Box key={index} display="inline">
            {isSearchLink(link) ? (
              <SearchLink
                variant="link"
                href={createSearchUrl({
                  filter: {
                    offerType: getOfferType(offer?.offerTypeId),
                  },
                  location: link.opts.location,
                })}
              >
                <Text
                  variant="medium"
                  textDecoration="underline"
                  cursor="pointer"
                  textColor="ud-primary"
                  _hover={{ color: "ud-primary-400" }}
                  display="inline-block"
                >
                  {text}
                </Text>
              </SearchLink>
            ) : (
              <CustomLink to={link.to} variant="link" showUnderline>
                <Text
                  variant="medium"
                  textDecoration="underline"
                  cursor="pointer"
                  textColor="ud-primary"
                  _hover={{ color: "ud-primary-400" }}
                  display="inline-block"
                >
                  {text}
                </Text>
              </CustomLink>
            )}
            {(navigations.length - 1 !== index || offer) && (
              <IconArrowRight fill="ud-grey-600" mx="4px" />
            )}
          </Box>
        ))}
        {offer && <OfferTitle offer={offer} />}
      </Box>
    </Box>
  );
};
export default BreadcrumbNavigation;
